import React, { useContext, useState, useEffect } from 'react';
import { MapContainer, TileLayer, WMSTileLayer, useMapEvents, Popup, useMap, Polygon } from 'react-leaflet';
import { AppContext } from '../components/AppContext';
import 'leaflet/dist/leaflet.css';
import PopupInfo from './PopupInfo';
import LeafletRuler from './LeafletRuler';

const MapViewer = () => {
  const { mapKey, mapData, setMap, center, setCenter, zoom, setZoom, geom, config } = useContext(AppContext);
  const [popupInfo, setPopupInfo] = useState({'lat':null, 'lng':null});
  const [popupClick, setPopupClick] = useState(false);

  const Map = () =>
    {
      const map = useMap()
      useEffect( () => {
        setMap(map)
    }, [map])
    return null;           
    }

  const MapEvents = () => {
    const map = useMapEvents({
      zoomend: () => {
        setZoom(map.getZoom());
        setCenter(map.getCenter())
      },
      moveend: () => {
        setCenter(map.getCenter());
      },
      click: async (e) => {
        const { lat, lng } = e.latlng;
        const url = `${config.map.geoserverUrl}?service=WMS&version=1.1.1&request=GetFeatureInfo&layers=sitios_disposición_final_limpio&styles=&bbox=${map.getBounds().toBBoxString()}&width=${map.getSize().x}&height=${map.getSize().y}&srs=EPSG:4326&query_layers=sitios_disposición_final_limpio&info_format=application/json&x=${Math.round(e.containerPoint.x)}&y=${Math.round(e.containerPoint.y)}`;

        const response = await fetch(url);
        const data = await response.json();
        if (data.features.length > 0) {
          const feature = data.features[0];
          setPopupInfo({
            lat,
            lng,
            info: feature.properties
          });
          setPopupClick(true);
        } else {
          setPopupInfo(null);
          setPopupClick(false);
        }
      }
    });

    return null;
  };
  const handlePopupClose = () => {
    setPopupClick(false);
  };

  const swapCoordinates = (coordinates) => {
    return coordinates.map(polygon =>
      polygon.map(ring =>
        ring.map(coordinate => [coordinate[1], coordinate[0]])
      )
    );
  };

  if (config) {
    return (
      <MapContainer key={mapKey} center={center} zoom={zoom} style={{ height: '100%', width: '100%' }} >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />     
        <WMSTileLayer
          url={config.map.geoserverUrl}
          layers={mapData.layer}
          styles={mapData.style}
          format="image/png"
          transparent={true}
          attribution="&copy; GeoServer"
          tileSize={256} 
          updateWhenIdle={true} 
          updateWhenZooming={false} 
        />
        <WMSTileLayer
          url={config.map.geoserverUrl}
          layers={mapData.location}
          styles={mapData.locationStyle}
          format="image/png"
          transparent={true}
          attribution="&copy; GeoServer"
          tileSize={256} 
          // updateWhenIdle={true} 
          updateWhenZooming={false} 
        />
        <Polygon
        positions={Array.isArray(geom) ? swapCoordinates(geom) : [] }
        pathOptions={{
          color: "#000000",
          weight: 4,
          fill: false,
        }}
        />
        <Polygon
        positions={Array.isArray(geom) ? swapCoordinates(geom) : [] }
        pathOptions={{
          color: "#FF0000",
          // color: "#FFFFFF",
          weight: 2,
          fill: false,
        }}
        />
        <WMSTileLayer
          url={config.map.geoserverUrl}
          layers={mapData.layer}
          styles={mapData.nameStyle}
          format="image/png"
          transparent={true}
          attribution="&copy; GeoServer"
          tileSize={512} 
          // updateWhenIdle={true} 
          updateWhenZooming={false} 
        />
        <WMSTileLayer
          url={config.map.geoserverUrl}
          layers="sitios_disposición_final_limpio"
          styles="Markers_sitios"
          format="image/png"
          transparent={true}
          attribution="&copy; GeoServer"
          tileSize={256} 
          // updateWhenIdle={true} 
          // updateWhenZooming={false} 
        />  
        <MapEvents />
        <Map />
        <LeafletRuler/>
        {popupClick && popupInfo.lat && popupInfo.lng && (
          <Popup
            position={[popupInfo.lat, popupInfo.lng]}
            closeButton={false}
            keepInView={false}
            autoPan={false}
          >
              <div>
              <div className="popup-header">
                <span>Información del Punto</span>
                <div className="popup-close" onClick={handlePopupClose}>
                  &times;
                </div>
              </div>
              <div className="popup-body">
                <PopupInfo mapInfo={popupInfo}></PopupInfo>
              </div>
            </div>
          </Popup>
      )}
      </MapContainer>
    );
  }
  
  return null;
};

export default MapViewer;
